/**
 * 모션 관련 공용 헬퍼.
 *
 * 전역 reduced-motion 정책(global.scss)은 CSS transition/animation 을 0.01ms 로 줄이지만,
 * JS 의 닫힘(언마운트) 타이머는 따르지 않는다. 그대로 두면 '동작 줄이기'에서 이미 보이지 않는
 * 오버레이가 원래 시간만큼 DOM 에 남고, 그동안 뒤로가기 계약(acquireOverlay)까지 붙잡는다.
 * 오버레이의 닫힘 타이머는 이 헬퍼로 대기 시간을 계산한다(정상 모션의 시간은 그대로).
 */

/** OS '동작 줄이기' 설정 여부. matchMedia 가 없는 환경(SSR 등)은 false. */
export const prefersReducedMotion = (): boolean => {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
};

/** 닫힘 애니메이션 대기 시간 — reduced-motion 이면 0, 아니면 ms 그대로. */
export const resolveExitMs = (ms: number): number => (prefersReducedMotion() ? 0 : ms);

/**
 * 오버레이 전환 시간(ms) — global.scss 의 --overlay-dim-duration·--overlay-panel-duration 과 같은 값.
 * CSS 쪽을 바꾸면 여기도 함께 바꾼다(닫힘 언마운트 대기가 전환보다 짧으면 닫히는 모습이 잘린다).
 */
export const OVERLAY_DIM_MS = 240;
export const OVERLAY_PANEL_MS = 280;
